// 通过lm获取lx
const lmClx = {
  '001': 'gzdt', // 工作动态
  '002': 'gywm', // 关于我们
  '003': 'zcfg', // 政策法规
  '007': 'djgz', // 党建工作
  '009': 'xspx', // 学习交流
  '008': 'zjzxwyh' // 专家介绍
}

// 通过lx获取lm
const lxClm = {
  gzdt: '001',
  gywm: '002',
  zcfg: '003',
  djgz: '007',
  xspx: '009'
}

// 通过lx获取中文
const lxCChinese = {
  gzdt: '工作动态',
  gywm: '关于我们',
  zcfg: '政策法规',
  djgz: '党建工作',
  xspx: '学习交流',
  fzjg: '分支机构',
  zjzxwyh: '健康卫士'
}

// 通过lm获取中文
const lmCChinese = {
  '001': '工作动态',
  '002': '关于我们',
  '003': '政策法规',
  '007': '党建工作',
  '009': '学习交流'
}

export default {
  lxClm,
  lmClx,
  lxCChinese,
  lmCChinese
}
